<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="h-8 w-8"
    :style="{ color: global.primaryColor }"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M10 19l-7-7m0 0l7-7m-7 7h18"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'IconArrowLeft',
  computed: {
    ...mapGetters(['global'])
  }
});
</script>
